import React from 'react';
import cs from 'classnames';

import Input from '~/components/pages/MyAccount/share/Input';
import LabeledInput from '~/components/common/LabeledInput';
import DropDown from '~/components/common/DropDown';
import {
  MenuList,
  MenuListItem,
} from '~/components/common/MenuList';
import {centTo$} from '~/misc/formatMoney';

import css from '../index.css';

const formatPrice = (props) => {
  const price = props.companyInfo.plan ? props.paymentInfo.data[props.companyInfo.plan].filter(item => item.show_name == props.companyInfo.billing)[0].discount_price : 0;
  return centTo$(price);
};

const formatOriginPrice = (props) => {
  const price = props.companyInfo.plan ? props.paymentInfo.data[props.companyInfo.plan].filter(item => item.show_name == props.companyInfo.billing)[0].origin_price : 0;
  return centTo$(price);
};

const formatRules = (props) => {
  if (props.companyInfo.billing) {
    return props.companyInfo.billing;
  }
  if (props.companyInfo.plan) {
    return props.paymentInfo.data[props.companyInfo.plan][0].show_name;
  }
  return props.paymentInfo.data[props.paymentInfo.plan][0].show_name;
};

const CompanyInfo = (props) => (
  <form className={css.formWrap}>
    <div className={css.dotMcWrap}>
      <div className={css.dotTitle}>DOT/MC</div>
      <div className={cs(css.comIdNumWrap)}>
        <div className={css.dotWrap}>
          <span
            onClick={props.changeDotOrMC}
            className={props.showDotInput ? cs(css.dotActive) : ''}
          >DOT</span>
          <span
            onClick={props.changeDotOrMC}
            className={props.showDotInput ? '' : cs(css.dotActive)}
          >MC</span>
        </div>
        <div className={css.strenchInput}>
          {props.showDotInput
            ? <Input
              mods={['strench']}
              label={'companyDot'}
              type='dot'
              defaultValue={props.companyInfo.companyDot || ''}
              fnChange={props.handleChange}
              fnBlur={props.blurDotMc}
              error={props.errorControl.companyDot ? props.errorControl.companyDot.error : ''}
            />
            : <Input
              mods={['strench']}
              label={'companyMc'}
              type='mc'
              defaultValue={props.companyInfo.companyMc || ''}
              fnChange={props.handleChange}
              fnBlur={props.blurDotMc}
              error={props.errorControl.companyMc ? props.errorControl.companyMc.error : ''}
            />
          }
        </div>
      </div>
    </div>
    < Input
      mods={
        ['floatRigt', 'half']
      }
      title='Company'
      label='company'
      type='text'
      readonly={true}
      defaultValue={
        props.companyInfo.company
      }
      error={
        props.errorControl.company ? props.errorControl.company.error : ''
      }
    />
    < DropDown
      data-qa={'bill-plan-dropdown'}
      id={'bill-plan-dropdown'}
      wrapClassName={cs(css.dropdown, css.floatLeft)}
      closeByClick={true}
      contentOverFlowScrolly={true}
      trigger={
        <LabeledInput
          data-qa={'dropdown-plan-input'}
          large={true}
          touched={true}
          label='Plan'
          value={props.companyInfo.plan ? props.companyInfo.plan : ''}
          error={props.errorControl.plan ? props.errorControl.plan.error : ''}
          icon='dropdown'
          tags={false}
          readOnly={true}
          blackLabel='blackLabel'
        />
      }
      content={(
        <div className={cs(css.dropdownContent, css.itemWrap, css.overHid)}>
          <MenuList data-qa={'menu-list-plan'}>
            {props.paymentInfo.plan.map((k, num) => (<MenuListItem
              className={cs('qa-item', `qa-item-${k}`)}
              key={num + k}
              name='plan'
              id={num + k}
              num={num}
              selected={Boolean(props.companyInfo.plan && (props.companyInfo.plan === k))}
              fn={props.handleToggle}
              title={k}
            />))
            }
          </MenuList>
        </div>)
      }
    />
    <div className={cs(css.dropdown, css.floatRigt)}>
      < DropDown
        data-qa={'bill-billing-dropdown'}
        id={'bill-billing-dropdown'}
        wrapClassName={css.strentch}
        closeByClick={true}
        contentOverFlowScrolly={true}
        trigger={
          <LabeledInput
            data-qa={'dropdown-billing-input'}
            large={true}
            touched={true}
            label='Billing'
            value={props.companyInfo.billing ? props.companyInfo.billing : ''}
            error={props.errorControl.billing ? props.errorControl.billing.error : ''}
            icon='dropdown'
            tags={false}
            readOnly={true}
            blackLabel='blackLabel'
          />
        }
        content={(
          <div className={cs(css.dropdownContent, css.itemWrap, css.overHid)}>
            <MenuList data-qa={'menu-list-billing'}>
              {props.paymentInfo.data[props.companyInfo.plan].map((k, num) => (<MenuListItem
                className={cs('qa-item', `qa-item-${k.show_name}`)}
                key={num + k.show_name}
                name='billing'
                id={num + k.show_name}
                num={num}
                selected={Boolean(props.companyInfo.billing && (props.companyInfo.billing === k.show_name))}
                fn={props.handleToggle}
                title={k.show_name}
              />))
              }
            </MenuList>
          </div>)}
      />
    </div>
    < Input
      mods={
        ['floatLef', 'strench']
      }
      title='User'
      label='user'
      type='seatNumber'
      defaultValue={
        props.companyInfo.user
      }
      fnChange={
        props.handleBlur
      }
      fnBlur={
        props.handleBlur
      }
      error={
        props.errorControl.user ? props.errorControl.user.error : ''
      }
    />
  </form>
);

export default CompanyInfo;



// WEBPACK FOOTER //
// ./src/components/pages/CreateAccount/CompanyInfo/index.js